import { render, staticRenderFns } from "./CreativesDiscrepancyModal.vue?vue&type=template&id=a61a23f6&scoped=true"
import script from "./CreativesDiscrepancyModal.vue?vue&type=script&lang=js"
export * from "./CreativesDiscrepancyModal.vue?vue&type=script&lang=js"
import style0 from "./CreativesDiscrepancyModal.vue?vue&type=style&index=0&id=a61a23f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61a23f6",
  null
  
)

export default component.exports